import { render, staticRenderFns } from "./SendTicketForm.vue?vue&type=template&id=106434ac&scoped=true"
import script from "./SendTicketForm.vue?vue&type=script&lang=ts"
export * from "./SendTicketForm.vue?vue&type=script&lang=ts"
import style0 from "./SendTicketForm.vue?vue&type=style&index=0&id=106434ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106434ac",
  null
  
)

export default component.exports